import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import ProblemLetter from "../components/sections/ProblemLetter";
import WhoSteps from "../components/sections/WhoSteps";
import Curriculum from "../components/sections/Curriculum";
import Host from "../components/sections/Host";
import Familiar from "../components/sections/Familiar";
import Takeaways from "../components/sections/Takeaways";
import Faq from "../components/sections/Faq";
import FinalCall from "../components/sections/FinalCall";
import useReveal from "../hooks/useReveal";

const Landing = () => {
  useReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#070b16] min-h-screen" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <ProblemLetter />
      <WhoSteps />
      <Curriculum />
      <Host />
      <Familiar />
      <Takeaways />
      <Faq />
      <FinalCall />
      <Footer />
    </div>
  );
};

export default Landing;
